import {Injectable} from '@angular/core';
import {HttpOption, StaticMethods} from '../model/GeneralModels';
import {FeedBackService} from './feed-back.service';
import {HttpClientWrapperService} from '../config/http-client-wrapper.service';
import {Coordinate} from 'ol/coordinate';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {catchError, retry} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OpenRouteService {

  constructor(private http: HttpClient,
              public feedBack: FeedBackService,
              private httpServer: HttpClientWrapperService) {
  }

  createAuthorizationHeader() {
    return new HttpHeaders(
      {
        Authorization: '5b3ce3597851110001cf62485604e977fe284fda8a057458a7054f23'
      });
  }

  getRouteOpenRoute(source: Coordinate, destination: Coordinate, profile: string) {
    console.log(source,
      destination);
    return this.http.post(`https://api.openrouteservice.org/v2/directions/${profile}/geojson`, {
      coordinates: [
        source,
        destination
      ]
    }, {
      headers: this.createAuthorizationHeader()
    }).pipe(retry(0), catchError(
      err => StaticMethods.handleError(err, this.feedBack)
    ));
  }

  getRouteServer(source: Coordinate, destination: Coordinate, profile: string) {
    console.log(source, destination);
    return this.httpServer.post(`openRouteService/router/${profile}`, {
      coordinates: [
        [source[1], source[0]],
        [destination[1], destination[0]]
      ]
    });
  }
}
